import React, { useState } from "react";
import RadioInput from "./RadioInput";
import SharedButton from "./SharedButton";
import TextInput from "./TextInput";
import { app_url, emailValidity } from "./Utils";
import { usePasswordValidation } from "./usePasswordValidation";

const INITIAL_DATA = {
  id: "",
  firstName: "",
  lastName: "",
  phoneNumber: "",
  client: "",
  email: "",
  isActive: false,
  role: "user",
  password: "",
  userName: "",
};
const INITIAL_ERROR = {
  firstName: false,
  lastName: false,
  phoneNumber: false,
  client: false,
  email: false,
  password: false,
  userName: false,
};

const UserModel = ({
  closeModel,
  currentUser,
  showLoader,
  handlelogout,
  getAllUsers,
  setAlert,
  lastRole,
}) => {
  const islogged = localStorage.getItem("islogged");

  const [userData, setUserData] = useState(
    currentUser ? currentUser : INITIAL_DATA
  );
  const [userError, setUserError] = useState(INITIAL_ERROR);
  const [passwordError, setPasswordError] = useState(null);
  const [validLength, hasNumber, upperCase, lowerCase, specialChar] =
    usePasswordValidation({
      firstPassword: userData?.password,
      secondPassword: userData?.password,
    });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
    setUserError({ ...userError, [name]: false });
  };

  const handleRadioChange = (event) => {
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
  };

  const addEditUser = async (user, isedit, role = "user", id = null) => {
    let isActive = JSON.parse(user.isActive);
    let isRoleUpdated = role !== lastRole ? true : false;
    if (isedit && !emailValidity(user.userName)) {
      setUserError({ ...userError, userName: true });
      showLoader(false);
      return false;
    }
    let data = isedit
      ? {
          Id: id,
          FirstName: user.firstName,
          LastName: user.lastName,
          Email: user.email,
          CompanyName: user.client,
          PhoneNumber: user.phoneNumber,
          IsActive: isActive,
          Role: user.role,
          IsRoleUpdate: true,
          UserName: user.userName,
        }
      : {
          FirstName: user.firstName,
          LastName: user.lastName,
          Email: user.email,
          CompanyName: user.client,
          PhoneNumber: user.phoneNumber,
          IsActive: isActive,
          Role: user.role,
          IsRoleUpdate: isRoleUpdated,
          Password: user.password,
        };
    await fetch(`${app_url}account/${isedit ? "edituser" : "adduser"}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${islogged}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 401) {
          handlelogout();
        } else {
          return response.json();
        }
      })
      .then((d) => {
        showLoader(false);
        if (d?.status === "Error") {
          setAlert("danger", d?.message);
        } else {
          setAlert("success", d?.message);
        }
        closeModel();
        getAllUsers();
      })
      .catch((error) => {
        console.error("Error:", error);
        showLoader(false);
        setAlert("danger", error);
        closeModel();
      });
  };

  const handleSubmitClick = (event) => {
    event.preventDefault();
    setPasswordError(null);
    let { firstName, lastName, phoneNumber, client, email, role } = userData;

    if (firstName === null || firstName.length === 0) {
      setUserError({ ...userError, firstName: true });
      return false;
    }
    if (lastName === null || lastName.length === 0) {
      setUserError({ ...userError, lastName: true });
      return false;
    }
    if (phoneNumber === null || phoneNumber.length === 0) {
      setUserError({ ...userError, phoneNumber: true });
      return false;
    }
    if (client === null || client.length === 0) {
      setUserError({ ...userError, client: true });
      return false;
    }
    if (email === null || !emailValidity(email)) {
      setUserError({ ...userError, email: true });
      return false;
    }

    if (currentUser === null) {
      if (!validLength) {
        setUserError({ ...userError, password: true });
        setPasswordError("Password Must Contain 8 Characters");
        return false;
      }
      if (!hasNumber) {
        setUserError({ ...userError, password: true });
        setPasswordError("Password Must Contain atleast 1 Number");
        return false;
      }
      if (!upperCase) {
        setUserError({ ...userError, password: true });
        setPasswordError("Password Must Contain atleast 1 Uppercase Letter");
        return false;
      }
      if (!lowerCase) {
        setUserError({ ...userError, password: true });
        setPasswordError("Password Must Contain atleast 1 Lowercase Letter");
        return false;
      }
      if (!specialChar) {
        setUserError({ ...userError, password: true });
        setPasswordError("Password Must Contain atleast 1 special character");
        return false;
      }
    }
    showLoader(true);

    if (currentUser) {
      addEditUser(userData, true, role, currentUser.id);
    } else {
      addEditUser(userData, false);
    }
  };

  return (
    <div className="cdk-overlay-container user-model">
      <div
        className="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"
        onClick={closeModel}
      ></div>
      <div className="cdk-global-overlay-wrapper">
        <div className="close-model" onClick={closeModel}>
          <i className="fa fa-close"></i>
        </div>
        <div id="cdk-overlay-0" className="cdk-overlay-pane">
          <div className="mat-dialog-container" id="mat-dialog-0">
            <div className="ng-star-inserted">
              <h2 className="mat-dialog-title" id="mat-dialog-title-0">
                User Edit Form
              </h2>
              <div className="mat-dialog-content">
                <p> Please fill out user data below </p>
                <form className="ng-pristine ng-valid ng-touched">
                  <div className="d-flex flex-wrap">
                    <TextInput
                      id="firstName"
                      inputType="text"
                      inputChange={handleInputChange}
                      value={userData.firstName}
                      label="First Name"
                      icon={"fa-user"}
                      error={userError.firstName}
                      isRequiredMark={true}
                    />
                    <TextInput
                      id="lastName"
                      inputType="text"
                      inputChange={handleInputChange}
                      value={userData.lastName}
                      label="Last Name"
                      icon={"fa-user"}
                      error={userError.lastName}
                      isRequiredMark={true}
                    />
                    <TextInput
                      id="phoneNumber"
                      inputType="text"
                      inputChange={handleInputChange}
                      value={userData.phoneNumber}
                      label="Phone Number"
                      icon={"fa-phone"}
                      error={userError.phoneNumber}
                      isRequiredMark={true}
                    />
                    <TextInput
                      id="client"
                      inputType="text"
                      inputChange={handleInputChange}
                      value={userData.client}
                      label="Client"
                      icon={"fa-user"}
                      error={userError.client}
                      isRequiredMark={true}
                    />
                    <TextInput
                      id="email"
                      inputType="email"
                      inputChange={handleInputChange}
                      value={userData.email}
                      label="Email"
                      icon={"fa-envelope"}
                      error={userError.email}
                      isRequiredMark={true}
                    />

                    {!currentUser ? (
                      <>
                        <TextInput
                          id="password"
                          inputType="text"
                          inputChange={handleInputChange}
                          value={userData.password}
                          label="Password"
                          icon={"fa-lock"}
                          error={userError.password}
                          isRequiredMark={true}
                        />
                        {passwordError ? (
                          <p className="pass-error">* {passwordError}</p>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      <TextInput
                        id="userName"
                        inputType="email"
                        inputChange={handleInputChange}
                        value={userData.userName}
                        label="UserName"
                        icon={"fa-envelope"}
                        error={userError.userName}
                        isRequiredMark={true}
                      />
                    )}
                    <div className="pr flex search-param f-wrap v-center">
                      <h5 className="m-0 user-radio-head">Active:</h5>
                      <div
                        className="radio-btn-groups user-radio isactive-radio"
                        onChange={handleRadioChange}
                      >
                        <RadioInput
                          id={"true"}
                          inputName="isActive"
                          label="Yes"
                          radioType={userData.isActive.toString()}
                        />
                        <RadioInput
                          id={"false"}
                          inputName="isActive"
                          label="No"
                          radioType={userData.isActive.toString()}
                        />
                      </div>
                    </div>
                    <div className="pr flex search-param f-wrap v-center">
                      <h5 className="m-0 user-radio-head">Role:</h5>
                      <div
                        className="radio-btn-groups user-radio role-radio"
                        onChange={handleRadioChange}
                      >
                        <RadioInput
                          id="user"
                          inputName="role"
                          label="User"
                          radioType={userData.role}
                        />
                        <RadioInput
                          id="admin"
                          inputName="role"
                          label="Admin"
                          radioType={userData.role}
                        />
                      </div>
                    </div>
                  </div>
                  <SharedButton
                    id="submit-btn"
                    addClass="btn-purple"
                    btnName="Submit"
                    handleClick={handleSubmitClick}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserModel;
